import type { Industry } from '../types/products';

export const industries: Industry[] = [
  {
    slug: 'metalworking',
    name: 'Metalworking',
    icon: 'gear',
    description:
      'Emulsifiers, cutting oils and rust preventives that keep machining, grinding and forming operations running with dependable corrosion control.',
    uses: ['Emulsifiers', 'Demulsifiers', 'Dispersing agents', 'Rust preventatives'],
    categorySlugs: ['petroleum-sulphonates', 'metalworking-fluids'],
  },
  {
    slug: 'oilfield',
    name: 'Oilfield',
    icon: 'rig',
    description:
      'Sulphonate chemistries used in flooding compounds, flocculants and crude oil emulsifiers for upstream operations.',
    uses: ['Flooding compounds', 'Flocculants', 'Crude oil emulsifiers', 'Bitumen frothing', 'Oilsand flotation'],
    categorySlugs: ['petroleum-sulphonates'],
  },
  {
    slug: 'mining',
    name: 'Mining',
    icon: 'mountain',
    description:
      'Flotation reagents supporting ore, phosphate and quartz sand separation processes.',
    uses: ['Ore flotation', 'Phosphate sand flotation', 'Quartz sand flotation'],
    categorySlugs: ['petroleum-sulphonates'],
  },
  {
    slug: 'industrial-oils',
    name: 'Industrial Oils',
    icon: 'droplet',
    description:
      'Multifunctional additives providing emulsification, wetting, rust prevention and detergency across industrial oil formulations.',
    uses: ['Emulsifiers', 'Wetting agents', 'Rust preventatives', 'Degreasing agents', 'Detergents'],
    categorySlugs: ['petroleum-sulphonates'],
  },
  {
    slug: 'textile',
    name: 'Textile',
    icon: 'thread',
    description:
      'Knitting and coning oil emulsifier packages engineered for high-speed processing, static protection and level dyeing.',
    uses: ['Knitting oils', 'Coning oils', 'Spin finishes', 'Level dyeing'],
    categorySlugs: ['textile-additives'],
  },
  {
    slug: 'fuel-automotive',
    name: 'Fuel & Automotive',
    icon: 'palette',
    description:
      'Solvent-soluble dyes for fuel marking, tax compliance and product branding across fuels, lubricants and jet oils.',
    uses: ['Fuel marking', 'Tax compliance', 'Lubricant branding', 'Product identification'],
    categorySlugs: ['fuel-petroleum-dyes'],
  },
];
